<div class="expert-text-div">
  <div class="expert-text-area-wrapper">
    <span
      class="expert-text-span"
      [innerHtml]="text | removeIndentPipe | safeHtml"
    ></span>
  </div>
</div>
